<div class="d-flex flex-column py-12 text-center position-relative h-75">
  <div class=" d-flex justify-content-center">
    <ng-lottie class="top-0 z-index-3 w-1000px" [options]="options"></ng-lottie>
  </div>
</div>
